import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from '@/components/editor/index';
import { company_desc_save } from '@/api/xinli';
export default {
  name: "addAppCustom",
  mixins: [],
  data: function data() {
    return {
      buttonLoading: false,
      refName: 'refName',
      hasShow: false,
      spinShow: false,
      formModel: {
        company_desc: null
      },
      formRules: {
        company_desc: [{
          required: true,
          message: '机构简介不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  props: {
    setData: {},
    title: {
      type: String,
      default: '机构介绍'
    }
  },
  components: {
    Editor: Editor
  },
  computed: {},
  methods: {
    cancel: function cancel() {
      this.showModal(false);
    },
    editorChange: function editorChange(html) {
      this.$set(this.formModel, 'company_desc', html);
    },
    submit: function submit() {
      var _this = this;

      this.$refs[this.refName].validate(function (valid) {
        if (valid) {
          var vm = _this;
          company_desc_save(_objectSpread({}, _this.formModel, {
            company_code: _this.setData.company_code
          })).then(function (res) {
            _this.buttonLoading = false;

            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.cancel();
              vm.$emit('init');
            } else {
              vm.$Message.error(res.errorMsg);
            }
          });
        }
      });
    },
    init: function init() {},
    handleUpload: function handleUpload(file, data) {
      this.uploadList.splice(0);
      return true;
    },
    showModal: function showModal(b) {
      this.hasShow = b;
    },
    onVisibleChange: function onVisibleChange(b) {
      var _this2 = this;

      if (b) {
        if (this.setData) {
          this.$set(this.formModel, 'company_desc', this.setData.company_desc);
          this.$nextTick(function () {
            _this2.$refs.Editor.setHtml(_this2.setData.company_desc);
          });
        }
      } else {}
    }
  },
  mounted: function mounted() {},
  created: function created() {}
};